export const HOST_QUERY_KEY = {
  GET_CONSOLE_CONFIG: 'GET_CONSOLE_CONFIG',
  GET_SCOPE: 'GET_SCOPE',
  GET_RECENT_PROJECT: 'GET_RECENT_PROJECT',
  GET_RECENT_REGION: 'GET_RECENT_REGION',
  GET_ACCESSIBLE_REGION: 'GET_ACCESSIBLE_REGION',
  GET_MEGA_MENU: 'GET_MEGA_MENU',
  GET_ALL_REGION_MEGA_MENU: 'GET_ALL_REGION_MEGA_MENU',
  GET_SERVICE_META: 'GET_SERVICE_META',
  GET_KEYWORD_ENDPOINT: 'GET_KEYWORD_ENDPOINT',
  GET_FAVORITE_SERVICE: 'GET_FAVORITE_SERVICE',
  ADD_FAVORITE_SERVICE: 'ADD_FAVORITE_SERVICE',
  DELETE_FAVORITE_SERVICE: 'DELETE_FAVORITE_SERVICE',
  EDIT_FAVORITE_SERVICE: 'EDIT_FAVORITE_SERVICE',
  GET_RECENT_SERVICE: 'GET_RECENT_SERVICE',
  GET_POPULAR_SERVICE: 'GET_POPULAR_SERVICE',
  GET_POPUP_ENABLED: 'GET_POPUP_ENABLED',
  UPDATE_RECENT_SERVICE: 'UPDATE_RECENT_SERVICE',
  UPDATE_RECENT_REGION: 'UPDATE_RECENT_REGION',
  UPDATE_RECENT_PROJECT: 'UPDATE_RECENT_PROJECT',
  GET_SERVICE_APP_INITIAL_STATE: 'GET_SERVICE_APP_INITIAL_STATE',
  GET_SERVICE_APP_ROUTE_STATE: 'GET_SERVICE_APP_ROUTE_STATE',
  GET_USER_PREFERENCE: 'GET_USER_PREFERENCE',
  GET_USER_SETTINGS: 'GET_USER_SETTINGS',
  UPDATE_USER_SETTINGS: 'UPDATE_USER_SETTINGS',
  // -------------IAM API---------------
  GET_IAM_ACCESS_TOKEN: 'GET_ACCESS_TOKEN',
  GET_IAM_ACCESSIBLE_PROJECT_LIST: 'GET_ACCESSIBLE_PROJECT_LIST',
  GET_IAM_USER_DETAIL_INFO: 'GET_USER_DETAIL_INFO',
  GET_IAM_DOMAIN_DETAIL_INFO: 'GET_IAM_DOMAIN_DETAIL_INFO',
  UPDATE_IAM_USER_DETAIL_INFO: 'UPDATE_IAM_USER_DETAIL_INFO',
  HEAD_IAM_AUTH_CHECK_PASSWORD: 'HEAD_IAM_AUTH_CHECK_PASSWORD',
};

export const HOST_SERVICE_QUERY_KEY = {
  GET_IAM_DOMAIN_DETAIL_INFO: 'GET_IAM_DOMAIN_DETAIL_INFO',
};
